import PropTypes from 'prop-types';
import {
  useEffect,
  useState,
} from 'react';

import { useTownAssets } from '../stores';

import SupportForm from './SupportForm';
import SvgColorImg from './SvgColorImg';

//
// Inline blue-underlined "support" link, used on dead-end pages to give
// stuck users a way to reach us. Opens the existing SupportForm popup.
//
// delayMs: if set, link stays hidden until the timeout fires — used on
// loading screens where appearing immediately would be alarmist.
//
const SupportLink = function SupportLink({ delayMs = 0, className = '' }) {
  const { assets: { translate } } = useTownAssets();
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(delayMs <= 0);

  useEffect(
    () => {
      if (delayMs <= 0) return undefined;
      const t = setTimeout(() => setVisible(true), delayMs);
      return () => clearTimeout(t);
    },
    [delayMs],
  );

  if (!visible) return null;

  const label = translate('helpDesk');

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`text-pxTxtLink hover:text-pxPrimaryFocus underline cursor-pointer inline-flex items-center gap-1.5 ${className}`}
        id="supportLink"
      >
        <SvgColorImg
          src="/images/svg/gui/helpDesk.svg"
          description={label}
          className="w-4 h-4 fill-pxTxtLink"
          imgColorAsCssFill
        />
        {label}
      </button>

      {(open)
        ? <SupportForm onClose={() => setOpen(false)} />
        : null}
    </>
  );
};

SupportLink.propTypes = {
  delayMs: PropTypes.number,
  className: PropTypes.string,
};

export default SupportLink;
